import React from "react";

const CONTACT_ITEMS = [
    {
        icon: "📧",
        label: "Email",
        value: "shara@bookedslot.com",
        href: "mailto:shara@bookedslot.com",
    },
    {
        icon: "📞",
        label: "Phone",
        value: "+91 94310 06463",
        href: "tel:+919431006463",
    },
    {
        icon: "🌐",
        label: "Website",
        value: "bookedslot.com",
        href: "https://bookedslot.com",
    },
    {
        icon: "📍",
        label: "Operating Region",
        value: "India (Expanding across major student hubs)",
        href: null,
    },
];

export default function Contact() {
    return (
        <div>
            {/* HERO */}
            <section className="relative bg-[#0A0B10] text-white overflow-hidden">
                <div className="absolute inset-0 bg-grid opacity-40" />
                <div className="relative mx-auto max-w-7xl px-6 pt-24 pb-20">
                    <div className="overline text-white/60 mb-6" data-testid="contact-eyebrow">
                        Get in Touch
                    </div>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[0.95]">
                        Contact <span className="text-[#FFB800]">Us</span>
                    </h1>
                    <p className="mt-6 text-lg text-white/70 max-w-2xl leading-relaxed">
                        Have questions, want to register your computer lab, or looking to partner
                        as an Ed-Tech provider? Reach out to our team directly.
                    </p>
                </div>
            </section>

            {/* CONTACT DETAILS */}
            <section className="mx-auto max-w-7xl px-6 py-20">
                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {CONTACT_ITEMS.map((item) => {
                        const Wrapper = item.href ? "a" : "div";
                        const wrapperProps = item.href
                            ? {
                                  href: item.href,
                                  target: item.href.startsWith("http") ? "_blank" : undefined,
                                  rel: item.href.startsWith("http") ? "noopener noreferrer" : undefined,
                              }
                            : {};
                        return (
                            <Wrapper
                                key={item.label}
                                {...wrapperProps}
                                className="border border-border p-6 bg-card hover:border-foreground hover:-translate-y-1 transition-all duration-150 block"
                                data-testid={`contact-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                <div className="text-3xl mb-4">{item.icon}</div>
                                <div className="overline mb-2">{item.label}</div>
                                <div className="font-heading text-lg font-bold break-words">{item.value}</div>
                            </Wrapper>
                        );
                    })}
                </div>
            </section>
        </div>
    );
}
